import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { AcompanhamentoProcessualOperacao, JanelaAcompanhamentoProcessual, SaidaLoteAcompanhamentoProcessualOperacaoDTO, FaseProcessual, EspecieAcaoRecurso, EntradaLoteAcompanhamentoProcessualOperacaoDTO } from '../../../model/acompanhamento-processual.model';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoProcessualService extends FgiBackEndService<AcompanhamentoProcessualOperacao> {

  // @Override
  getNewEntity() {
    const novo = new AcompanhamentoProcessualOperacao();
    novo.dataEnvio = new Date();
    return novo; 
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/acompanhamento-processual-operacao';
  }

  getFasesProcessuais(): Observable<FaseProcessual[]> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/dominio/fase-processual`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<FaseProcessual[]>;
  }

  getEspeciesAcaoRecurso(): Observable<EspecieAcaoRecurso[]> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/dominio/especie-acao-recurso`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<EspecieAcaoRecurso[]>;
  }

  getOperacoesQuePrecisamSerInformadas(cnpjAgenteFinanceiro: string): Observable<SaidaLoteAcompanhamentoProcessualOperacaoDTO> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/agente-financeiro/${cnpjAgenteFinanceiro}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<SaidaLoteAcompanhamentoProcessualOperacaoDTO>;
  }

  getJanelaAtual(): Observable<JanelaAcompanhamentoProcessual> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/janela`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<JanelaAcompanhamentoProcessual>;
  }

  getAcompanhamentos(params?: any):any{
    let options: any = blockUi();
    options.params = params;        
    return this.http.get(`${this.BASE_URL}`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<AcompanhamentoProcessualOperacao>>;
  }

  salvarLote(lote: EntradaLoteAcompanhamentoProcessualOperacaoDTO, apenasValidar: boolean): Observable<MensagemRetornoAssincrono> {

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}`, lote, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<MensagemRetornoAssincrono>;
  }

}
